import { Icon } from '@advanza/ui'
import A from 'components/ui/A'
import { format, parseISO } from 'date-fns'
import { ReclaimDoubleLeadData } from 'interfaces/Reclaims'

const formatDuration = (seconds: number): string => {
    if (seconds === 0) return 'Missed call'
    const mins = Math.floor(seconds / 60)
    const secs = seconds % 60
    if (mins === 0) return `${secs}s`
    return `${mins}m ${secs}s`
}

interface ReclaimReasonExplanationProps {
    explanation?: string | null
    doubleLead?: ReclaimDoubleLeadData | null
}

const ReclaimReasonExplanation = ({ explanation, doubleLead }: ReclaimReasonExplanationProps) => {
    const matchId = doubleLead?.match_id
    const phoneClick = doubleLead?.phone_click

    return (
        <div className="flex flex-col gap-4">
            {doubleLead && (
                <div>
                    <div className="font-bold mb-1">Chosen double lead:</div>
                    {matchId && (
                        <div className="grid grid-cols-[auto_1fr] gap-1">
                            <div>Match:</div>
                            <div>
                                <A
                                    className="classic text-primary-600"
                                    to={`/service/matches/match/${matchId}`}
                                    external={false}>
                                    #{matchId}
                                </A>
                            </div>
                        </div>
                    )}
                    {phoneClick && (
                        <div className="grid grid-cols-[auto_1fr] gap-1">
                            <div>Phone click:</div>
                            <div>#{phoneClick.phone_click_id}</div>
                            <div>Phone number:</div>
                            <div>{phoneClick.phone_number}</div>
                            <div>Date:</div>
                            <div>{format(parseISO(phoneClick.created), 'd-MMM-yyyy HH:mm')}</div>
                            <div>Duration:</div>
                            <div>{formatDuration(phoneClick.seconds_open)}</div>
                        </div>
                    )}
                    {doubleLead.via_other_platform && (
                        <div>
                            <Icon name="check_box" fontSize={21} /> Known via other platform
                        </div>
                    )}
                </div>
            )}
            {explanation && (
                <div>
                    <div className="font-bold mb-1">User explanation:</div>
                    <div>{explanation}</div>
                </div>
            )}
        </div>
    )
}

export default ReclaimReasonExplanation
